import { render } from "./QuickStartWindow.vue?vue&type=template&id=21a5e7b0&scoped=true"
import script from "./QuickStartWindow.vue?vue&type=script&lang=js"
export * from "./QuickStartWindow.vue?vue&type=script&lang=js"

import "./QuickStartWindow.vue?vue&type=style&index=0&id=21a5e7b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a5e7b0"]])

export default __exports__